import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "container-fix-padding" }
const _hoisted_2 = { class: "d-flex justify-center py-4" }
const _hoisted_3 = { class: "category-sidebar px-4 py-3" }
const _hoisted_4 = { class: "category-count" }
const _hoisted_5 = { class: "category-count" }
const _hoisted_6 = { class: "category-count" }
const _hoisted_7 = { class: "category-sidebar pa-3" }
const _hoisted_8 = { class: "category-count" }
const _hoisted_9 = { class: "category-count" }
const _hoisted_10 = { class: "category-count" }

import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Enrollment from '../../../api/v2/models/enrollment'
import Tag from '../../../api/v2/models/course_tag'
import api from '../../../api/v2/api'
import { headerState } from '../../stores/header'
import { checkMobile } from '../../utils/utils'
import { getQueryString, getQueryNumber } from '../../../../helpers/route-helper'
import CourseMy from '../atoms_molecules/CourseMy.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CourseMyList',
  setup(__props) {

const route = useRoute()
const router = useRouter()

// Reactive Data
const mobile = ref(checkMobile())
const tags = ref<Tag[]>([])
const enrollments = ref<Enrollment[]>([])
const drawerRight = ref(!mobile.value)
const search = ref('')
const breadcrumbs = ref([
  {
    text: 'クラスルーム',
    disabled: false,
    exact: true,
    to: '/classroom/'
  },
  {
    text: 'マイコース一覧',
    disabled: false,
    exact: true,
    to: '/classroom/my-courses'
  }
])
const page = ref(1)
const isEnd = ref(false)
const loading = ref(false)
const config = ref<Record<string, any>>({})
const totalEnrollmentsCount = ref(0)

// Computed
const totalCourseCount = computed(() => 
  tags.value.reduce((sum, tag) => sum + (tag.courseCount || 0), 0)
)

const untaggedCourseCount = computed(() => 
  Math.max(0, totalEnrollmentsCount.value - totalCourseCount.value)
)

const currentTag = computed(() => getQueryString(route.query, 'tag'))
const currentTagNumber = computed(() => getQueryNumber(route.query, 'tag'))

// Functions
async function loadList(loadMore = false, newConfig: Record<string, any> | undefined = undefined) {
  if (loading.value) {
    return
  }

  if (!loadMore) {
    page.value = 1
    enrollments.value = []
    isEnd.value = false
    config.value = newConfig || {}
  } else {
    if (isEnd.value) {
      return
    }
    page.value += 1
  }
  try {
    loading.value = true

    const more = await api.enrollment.index(config.value, page.value)
    enrollments.value = [...enrollments.value, ...more]

    if (more.length < 20) {
      isEnd.value = true
    }
  } finally {
    loading.value = false
  }
}

function resetTag() {
  router.push({ query: {} })
}

function lessonId(course: any) {
  return course.lessons[0].id
}

function setTag(id: number) {
  router.push({ query: { tag: id } })
}

function setNoTag() {
  router.push({ query: { tag: 'no_tag' } })
}

function handleScroll(e: Event) {
  const el = document.documentElement
  if (el.clientHeight + el.scrollTop >= el.scrollHeight) {
    loadList(true)
  }
}

// Watchers
watch(search, async () => {
  const listId = currentTag.value
  await loadList(false, { tagId: listId, search: search.value })
})

watch(() => route.query, async () => {
  const listId = currentTag.value
  await loadList(false, { tagId: listId })
}, { immediate: true })

// Lifecycle
onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll)
})

// Created logic
;(async () => {
  headerState.setTitle('マイコース一覧')
  const listId = currentTag.value
  await loadList(false, { tagId: listId })
  tags.value = await api.courseTag.my()
  // Get total count for untagged calculation
  const allEnrollments = await api.enrollment.index({}, 0)
  totalEnrollmentsCount.value = allEnrollments.length
})()

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcrumb, { items: [
      { text: 'クラスルーム', to: '/classroom/' },
      { text: 'マイコース一覧' }
    ] }),
    _createCommentVNode(" Main content: 2-column layout "),
    _createVNode(_component_v_row, {
      class: "ma-0",
      style: { minHeight: '700px' }
    }, {
      default: _withCtx(() => [
        _createCommentVNode(" Left column: Course list "),
        _createVNode(_component_v_col, {
          cols: "12",
          lg: "8",
          class: "pt-0 bg-white"
        }, {
          default: _withCtx(() => [
            _createCommentVNode(" Search bar row "),
            _createVNode(_component_v_row, {
              class: "align-center px-3 py-2",
              "no-gutters": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "8",
                  md: "9"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: search.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                      placeholder: "コース名を入力してください",
                      "prepend-inner-icon": "mdi-magnify",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      clearable: ""
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_col, {
                  cols: "4",
                  md: "3",
                  class: "d-flex justify-end align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "outlined",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (search.value = ''))
                    }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode("クリア", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createCommentVNode(" Course list "),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(enrollments.value, (enrollment) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: enrollment.id
              }, [
                _createVNode(CourseMy, { enrollment: enrollment }, null, 8 /* PROPS */, ["enrollment"]),
                _createVNode(_component_v_divider)
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */)),
            _createCommentVNode(" Loading indicator "),
            _createElementVNode("div", _hoisted_2, [
              (loading.value)
                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                    key: 0,
                    indeterminate: "",
                    color: "green"
                  }))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _: 1 /* STABLE */
        }),
        _createCommentVNode(" Right column: Categories (desktop only) "),
        (!mobile.value)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 0,
              cols: "12",
              lg: "4",
              class: "bg-white"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "category-header d-flex align-center justify-space-between mb-3" }, [
                    _createElementVNode("div", { class: "d-flex align-center gap-2" }, [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "20",
                        height: "20",
                        viewBox: "0 0 24 24",
                        fill: "currentColor",
                        class: "text-primary"
                      }, [
                        _createElementVNode("path", { d: "M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM9 9H5V5h4v4zm11-6h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 6h-4V5h4v4zm-9 4H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm-1 6H5v-4h4v4zm8-6c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z" })
                      ]),
                      _createElementVNode("span", { class: "text-h6 font-weight-bold" }, "カテゴリー")
                    ])
                  ], -1 /* CACHED */)),
                  _createCommentVNode(" Clear/All courses button "),
                  _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (resetTag())),
                    class: _normalizeClass(["category-clear-btn d-flex align-center gap-2 pa-3 mb-2 rounded-lg", { 'active': !currentTag.value }])
                  }, [
                    _cache[9] || (_cache[9] = _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "18",
                      height: "18",
                      viewBox: "0 0 24 24",
                      fill: "currentColor"
                    }, [
                      _createElementVNode("path", { d: "M4 6h16v2H4zm2 4h12v2H6zm2 4h8v2H8z" })
                    ], -1 /* CACHED */)),
                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "font-weight-medium" }, "すべてのコース", -1 /* CACHED */)),
                    _createVNode(_component_v_spacer),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(totalCourseCount.value), 1 /* TEXT */)
                  ], 2 /* CLASS */),
                  _createVNode(_component_v_divider, { class: "mb-2" }),
                  _createCommentVNode(" Tag list "),
                  _createVNode(_component_v_list, {
                    class: "category-list pa-0",
                    "bg-color": "transparent"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: tag.id,
                          onClick: ($event: any) => (setTag(tag.id)),
                          active: tag.id == currentTagNumber.value,
                          class: "category-item rounded-lg mb-1",
                          link: ""
                        }, {
                          prepend: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                            _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "currentColor",
                              class: "me-2 text-grey"
                            }, [
                              _createElementVNode("path", { d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" })
                            ], -1 /* CACHED */)
                          ]))]),
                          append: _withCtx(() => [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(tag.courseCount), 1 /* TEXT */)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "font-weight-medium" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(tag.name), 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "active"]))
                      }), 128 /* KEYED_FRAGMENT */)),
                      _createCommentVNode(" No tag item "),
                      (untaggedCourseCount.value > 0)
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 0,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (setNoTag())),
                            active: currentTag.value === 'no_tag',
                            class: "category-item rounded-lg mb-1",
                            link: ""
                          }, {
                            prepend: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                              _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "currentColor",
                                class: "me-2 text-grey"
                              }, [
                                _createElementVNode("path", { d: "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z" })
                              ], -1 /* CACHED */)
                            ]))]),
                            append: _withCtx(() => [
                              _createElementVNode("span", _hoisted_6, _toDisplayString(untaggedCourseCount.value), 1 /* TEXT */)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, { class: "font-weight-medium" }, {
                                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                  _createTextVNode("タグなし", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["active"]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" Mobile menu button "),
    (_openBlock(), _createBlock(_Teleport, { to: "#header-right" }, [
      (mobile.value)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            icon: "",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (drawerRight.value = !drawerRight.value), ["stop"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                  _createTextVNode("mdi-menu", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ])),
    _createCommentVNode(" Mobile drawer "),
    (_openBlock(), _createBlock(_Teleport, { to: "#header-right-drawer" }, [
      (mobile.value)
        ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
            key: 0,
            modelValue: drawerRight.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((drawerRight).value = $event)),
            location: "right",
            temporary: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "category-header d-flex align-center gap-2 mb-3" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "20",
                    height: "20",
                    viewBox: "0 0 24 24",
                    fill: "currentColor",
                    class: "text-primary"
                  }, [
                    _createElementVNode("path", { d: "M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM9 9H5V5h4v4zm11-6h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 6h-4V5h4v4zm-9 4H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm-1 6H5v-4h4v4zm8-6c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z" })
                  ]),
                  _createElementVNode("span", { class: "text-h6 font-weight-bold" }, "カテゴリー")
                ], -1 /* CACHED */)),
                _createCommentVNode(" Clear/All courses button "),
                _createElementVNode("div", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => {resetTag(); drawerRight.value = false}),
                  class: _normalizeClass(["category-clear-btn d-flex align-center gap-2 pa-3 mb-2 rounded-lg", { 'active': !currentTag.value }])
                }, [
                  _cache[16] || (_cache[16] = _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "18",
                    height: "18",
                    viewBox: "0 0 24 24",
                    fill: "currentColor"
                  }, [
                    _createElementVNode("path", { d: "M4 6h16v2H4zm2 4h12v2H6zm2 4h8v2H8z" })
                  ], -1 /* CACHED */)),
                  _cache[17] || (_cache[17] = _createElementVNode("span", { class: "font-weight-medium" }, "すべてのコース", -1 /* CACHED */)),
                  _createVNode(_component_v_spacer),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(totalCourseCount.value), 1 /* TEXT */)
                ], 2 /* CLASS */),
                _createVNode(_component_v_divider, { class: "mb-2" }),
                _createCommentVNode(" Tag list "),
                _createVNode(_component_v_list, {
                  class: "category-list pa-0",
                  "bg-color": "transparent"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: tag.id,
                        onClick: ($event: any) => {setTag(tag.id); drawerRight.value = false},
                        active: tag.id == currentTagNumber.value,
                        class: "category-item rounded-lg mb-1",
                        link: ""
                      }, {
                        prepend: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                          _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "currentColor",
                            class: "me-2 text-grey"
                          }, [
                            _createElementVNode("path", { d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" })
                          ], -1 /* CACHED */)
                        ]))]),
                        append: _withCtx(() => [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(tag.courseCount), 1 /* TEXT */)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "font-weight-medium" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tag.name), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "active"]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    _createCommentVNode(" No tag item "),
                    (untaggedCourseCount.value > 0)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 0,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => {setNoTag(); drawerRight.value = false}),
                          active: currentTag.value === 'no_tag',
                          class: "category-item rounded-lg mb-1",
                          link: ""
                        }, {
                          prepend: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                            _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "currentColor",
                              class: "me-2 text-grey"
                            }, [
                              _createElementVNode("path", { d: "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z" })
                            ], -1 /* CACHED */)
                          ]))]),
                          append: _withCtx(() => [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(untaggedCourseCount.value), 1 /* TEXT */)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "font-weight-medium" }, {
                              default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                _createTextVNode("タグなし", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["active"]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"]))
        : _createCommentVNode("v-if", true)
    ]))
  ]))
}
}

})